module.exports = __webpack_public_path__ + "static/increase-productivity-0687b648b05e5a57e90ef77152a5a163.svg";